/** Line height (px) aligned with body-3/body-4 typography tokens (24px). */
export const AUTO_GROW_LINE_HEIGHT_PX = 24;

export const AUTO_GROW_MAX_LINES = 4;

export const AUTO_GROW_MAX_HEIGHT_PX =
  AUTO_GROW_LINE_HEIGHT_PX * AUTO_GROW_MAX_LINES;

/** Grows a textarea up to {@link AUTO_GROW_MAX_LINES} lines, then scrolls with overflow hidden via CSS. */
export function resizeTextareaToContent(textarea: HTMLTextAreaElement): void {
  if (!textarea.value) {
    textarea.style.height = "";
    textarea.style.overflowY = "hidden";
    return;
  }
  textarea.style.height = "auto";
  const scrollHeight = textarea.scrollHeight;
  const cappedHeight = Math.max(
    AUTO_GROW_LINE_HEIGHT_PX,
    Math.min(scrollHeight, AUTO_GROW_MAX_HEIGHT_PX),
  );
  textarea.style.height = `${cappedHeight}px`;
  textarea.style.overflowY =
    scrollHeight > AUTO_GROW_MAX_HEIGHT_PX ? "auto" : "hidden";
}
